module.exports = __webpack_public_path__ + "img/item-img.f332e1b8.png";